module.exports = __webpack_public_path__ + "static/media/demand.e5ff46fc.svg";